export default "__VITE_ASSET__DgoCbDDy__"